export function tags(tag) {
  return {
    serverId: tag.id,
    name: tag.name,
  }
}

